import { render, staticRenderFns } from "./ConfirmDeletion.vue?vue&type=template&id=8482a782&scoped=true"
import script from "./ConfirmDeletion.vue?vue&type=script&lang=ts"
export * from "./ConfirmDeletion.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmDeletion.vue?vue&type=style&index=0&id=8482a782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8482a782",
  null
  
)

export default component.exports